const moduleName = 'listingManagementStats';
const mod = angular.module(moduleName, [])
  .config(function ($stateProvider) {

    $stateProvider
      .state('listingManagementStats', {
        url: '/listingManagement',
        abstract: true,
        template: '<ui-view/>'
      })
      .state('listingManagementStats.recentLocations', {
        url: '/listingManagementStats/recentLocations',
        template: require('./listingManagementRecentLocations.html'),
        controller: 'listingManagementRecentLocationsCtrl'
      })
  });

require('./listingManagementRecentLocationsController').default(mod);

module.exports = moduleName;
